module.exports = __webpack_public_path__ + "media/images/team/VitoriaNunesVicente-6630061a7115d88fae04f7636d95dd9a.png";